import { useBranding, useCurrentBranch } from "../api/queries";
import { cn } from "../lib/cn";

/** Tenant logo, or a blue tile with the business initial (§6.1), plus business and branch. */
export function BrandTile({
  size = 36,
  className,
}: {
  size?: number;
  className?: string;
}) {
  const b = useBranding().data;
  const branch = useCurrentBranch().data;
  const name = branch?.businessName || b?.businessName || "BaraPOS";
  if (b?.logo)
    return (
      <img
        src={b.logo}
        alt=""
        className={cn(
          "shrink-0 rounded-[10px] bg-white object-contain ring-1 ring-line",
          className,
        )}
        style={{ width: size, height: size }}
      />
    );
  return (
    <span
      aria-hidden="true"
      className={cn(
        "inline-flex shrink-0 items-center justify-center rounded-[10px] bg-gradient-to-br from-primary to-glow font-extrabold text-white shadow-[0_8px_20px_-8px_var(--hero-glow)] ring-1 ring-inset ring-white/20",
        className,
      )}
      style={{ width: size, height: size, fontSize: size * 0.45 }}
    >
      {name.trim().charAt(0).toUpperCase() || "B"}
    </span>
  );
}

/** The business name the admin edits in Settings → Branch details wins, then the branding
 * record's name (set at signup; Settings has no field for it). The invoice uses the same order,
 * so the sidebar, top bar and invoice never disagree. */
export function useBusinessNames(): {
  business: string;
  branch: string | null;
} {
  const b = useBranding().data;
  const branch = useCurrentBranch().data;
  return {
    business: branch?.businessName || b?.businessName || "BaraPOS",
    branch: branch?.name ?? null,
  };
}
